import type { ApiErrorCodeI18nPatternRule } from "./error-code-i18n-pattern-types";

// Business-domain resource error-code i18n pattern rules.
export const API_ERROR_CODE_I18N_DOMAIN_RESOURCE_PATTERN_RULES: readonly ApiErrorCodeI18nPatternRule[] =
  [
    {
      prefix: "aitest.evidence.test_task.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestEvidenceTestTask",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "aitest.issue.test_task.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestIssueTestTask",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "edu.course.",
      resourceI18nKey: "common.errors.apiCodeResources.eduCourse",
      reasonCodes: ["data_contract_invalid", "field_required", "not_found"],
    },
    {
      prefix: "edu.learning_record.",
      resourceI18nKey: "common.errors.apiCodeResources.eduLearningRecord",
      reasonCodes: ["data_contract_invalid", "not_found"],
    },
    {
      prefix: "edu.member.",
      resourceI18nKey: "common.errors.apiCodeResources.eduMember",
      reasonCodes: [
        "already_exists",
        "data_contract_invalid",
        "duplicate_user_id",
        "invalid_roles",
        "not_found",
        "user_id_required",
        "username_required",
      ],
    },
    {
      prefix: "edu.org.",
      resourceI18nKey: "common.errors.apiCodeResources.eduOrg",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "edu.overview.learner_message.",
      resourceI18nKey: "common.errors.apiCodeResources.eduOverviewLearnerMessage",
      reasonCodes: ["data_contract_invalid"],
    },
    {
      prefix: "edu.project.",
      resourceI18nKey: "common.errors.apiCodeResources.eduProject",
      reasonCodes: [
        "data_contract_invalid",
        "not_found",
        "notice_content_required",
        "notice_title_required",
        "title_required",
      ],
    },
    {
      prefix: "edu.public_course.",
      resourceI18nKey: "common.errors.apiCodeResources.eduPublicCourse",
      reasonCodes: [
        "data_contract_invalid",
        "field_required",
        "not_found",
        "notice_content_required",
        "notice_title_required",
      ],
    },
    {
      prefix: "edu.teaching_plan.",
      resourceI18nKey: "common.errors.apiCodeResources.eduTeachingPlan",
      reasonCodes: [
        "data_contract_invalid",
        "field_required",
        "not_found",
        "notice_content_required",
        "notice_title_required",
      ],
    },
    {
      prefix: "exam.attempt.",
      resourceI18nKey: "common.errors.apiCodeResources.examAttempt",
      reasonCodes: ["data_contract_invalid"],
    },
    {
      prefix: "exam.exam.",
      resourceI18nKey: "common.errors.apiCodeResources.examExam",
      reasonCodes: ["data_contract_invalid"],
    },
    {
      prefix: "exam.paper.",
      resourceI18nKey: "common.errors.apiCodeResources.examPaper",
      reasonCodes: ["data_contract_invalid", "not_found", "title_required"],
    },
    {
      prefix: "exam.paper_item.",
      resourceI18nKey: "common.errors.apiCodeResources.examPaperItem",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "exam.paper_version.",
      resourceI18nKey: "common.errors.apiCodeResources.examPaperVersion",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "exam.platform.",
      resourceI18nKey: "common.errors.apiCodeResources.examPlatform",
      reasonCodes: ["data_contract_invalid"],
    },
    {
      prefix: "exam.review.",
      resourceI18nKey: "common.errors.apiCodeResources.examReview",
      reasonCodes: ["data_contract_invalid"],
    },
    {
      prefix: "exam.user.",
      resourceI18nKey: "common.errors.apiCodeResources.examUser",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "micro_lab.library_entry.",
      resourceI18nKey: "common.errors.apiCodeResources.microLabLibraryEntry",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "micro_lab.member.",
      resourceI18nKey: "common.errors.apiCodeResources.microLabMember",
      reasonCodes: [
        "already_exists",
        "duplicate_user_id",
        "invalid_roles",
        "not_found",
        "user_id_required",
        "username_required",
      ],
    },
    {
      prefix: "micro_lab.release.",
      resourceI18nKey: "common.errors.apiCodeResources.microLabRelease",
      reasonCodes: ["already_archived", "not_found"],
    },
    {
      prefix: "micro_lab.run.",
      resourceI18nKey: "common.errors.apiCodeResources.microLabRun",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "micro_lab.scheme.",
      resourceI18nKey: "common.errors.apiCodeResources.microLabScheme",
      reasonCodes: [
        "access_forbidden",
        "already_archived",
        "edit_requires_draft",
        "not_found",
        "write_forbidden",
      ],
    },
    {
      prefix: "micro_lab.scheme_version.",
      resourceI18nKey: "common.errors.apiCodeResources.microLabSchemeVersion",
      reasonCodes: ["edit_requires_draft", "not_found"],
    },
    {
      prefix: "redblue.activity.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueActivity",
      reasonCodes: ["code_sequence_exhausted", "not_found"],
    },
    {
      prefix: "redblue.activity_camp.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueActivityCamp",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "redblue.activity_member.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueActivityMember",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "redblue.activity_seat.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueActivitySeat",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "redblue.activity_task.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueActivityTask",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "redblue.director.activity_tasks.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueDirectorActivityTasks",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "redblue.director.dispatch_target.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueDirectorDispatchTarget",
      reasonCodes: ["ref_required", "type_required", "unsupported_type"],
    },
    {
      prefix: "redblue.director.event_subject.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueDirectorEventSubject",
      reasonCodes: ["ref_required", "type_required", "unsupported_type"],
    },
    {
      prefix: "redblue.director.notice_target.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueDirectorNoticeTarget",
      reasonCodes: ["target_ref_not_allowed", "target_ref_required", "unsupported_type"],
    },
    {
      prefix: "redblue.judge.score_record.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueJudgeScoreRecord",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "redblue.member.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueMember",
      reasonCodes: [
        "already_exists",
        "duplicate_user_id",
        "invalid_roles",
        "not_found",
        "user_id_required",
        "username_required",
      ],
    },
    {
      prefix: "redblue.participant.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueParticipant",
      reasonCodes: ["user_id_required"],
    },
    {
      prefix: "redblue.participant.report.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueParticipantReport",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "redblue.participant.report_template.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueParticipantReportTemplate",
      reasonCodes: ["not_found"],
    },
    {
      prefix: "redblue.scheme.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueScheme",
      reasonCodes: [
        "access_forbidden",
        "already_archived",
        "code_sequence_exhausted",
        "edit_requires_draft",
        "not_found",
        "write_forbidden",
      ],
    },
    {
      prefix: "redblue.scheme_version.",
      resourceI18nKey: "common.errors.apiCodeResources.redblueSchemeVersion",
      reasonCodes: ["not_found", "parent_scheme_missing"],
    },
    {
      prefix: "aitest.evidence.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestEvidence",
      reasonCodes: ["asset_ref_required", "name_required"],
    },
    {
      prefix: "aitest.intelligent_runner.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestIntelligentRunner",
      reasonCodes: [
        "callback_binding_invalid",
        "callback_signing_secret_missing",
        "callback_token_expired",
        "callback_token_invalid",
        "callback_token_required",
      ],
    },
    {
      prefix: "aitest.issue.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestIssue",
      reasonCodes: ["severity_invalid", "title_required"],
    },
    {
      prefix: "aitest.orchestration.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestOrchestration",
      reasonCodes: [
        "destroy_request_id_missing",
        "instance_business_context_invalid",
        "instance_contract_invalid",
        "instance_source_type_invalid",
        "mixed_instance_kinds",
        "operator_context_invalid",
        "operator_role_invalid",
        "runtime_target_snapshot_invalid",
        "standalone_runtime_target_snapshot_forbidden",
        "status_contract_invalid",
        "submit_payloads_missing",
        "submit_request_id_missing",
        "topology_attachment_invalid",
        "topology_business_context_invalid",
        "topology_request_id_missing",
      ],
    },
    {
      prefix: "aitest.runtime.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestRuntime",
      reasonCodes: ["schema_not_ready"],
    },
    {
      prefix: "aitest.smart_asset.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestSmartAsset",
      reasonCodes: ["mcp_execution_contract_invalid"],
    },
    {
      prefix: "aitest.test_task.",
      resourceI18nKey: "common.errors.apiCodeResources.aitestTestTask",
      reasonCodes: [
        "execution_config_network_mode_removed",
        "execution_image_declared_ports_invalid",
        "execution_image_default_spec_required",
        "execution_image_identity_mismatch",
        "execution_image_kind_not_allowed",
        "execution_image_kind_required",
        "execution_image_required",
        "experiment_status_invalid",
        "image_snapshot_actor_required",
        "submit_payload_invalid",
        "destroy_source_type_invalid",
        "management_access_required",
        "quota_owner_change_forbidden",
        "quota_owner_member_not_found",
        "quota_owner_not_task_tester",
        "quota_owner_user_id_invalid",
        "status_transition_invalid",
        "runtime_params_network_contract_managed",
        "runtime_params_placement_forbidden",
        "target_service_snapshot_removed",
        "test_instance_binding_runtime_kind_required",
        "test_instance_binding_spec_required",
      ],
    },
    {
      prefix: "ctf.dependency.",
      resourceI18nKey: "common.errors.apiCodeResources.ctfDependency",
      reasonCodes: ["database_unavailable"],
    },
    {
      prefix: "ctf.runtime.",
      resourceI18nKey: "common.errors.apiCodeResources.ctfRuntime",
      reasonCodes: ["config_invalid"],
    },
    {
      prefix: "edu.course.",
      resourceI18nKey: "common.errors.apiCodeResources.eduCourse",
      reasonCodes: ["scheme_catalog_course_unflushed", "scheme_catalog_missing"],
    },
    {
      prefix: "edu.learning_record.",
      resourceI18nKey: "common.errors.apiCodeResources.eduLearningRecord",
      reasonCodes: [
        "completion_requires_in_progress",
        "course_not_found",
        "course_reset_not_available",
        "course_task_not_in_record",
        "inactive_member_cannot_start_public_course",
        "invalid_external_id",
        "lesson_locked",
        "lesson_not_in_course",
        "lesson_not_in_plan_snapshot",
        "member_not_found",
        "not_startable",
        "plan_binding_completed",
        "plan_binding_historical",
        "plan_binding_status_invalid",
        "plan_exam_task_paper_binding_missing",
        "plan_review_only_after_end",
        "plan_snapshot_missing",
        "plan_start_requires_published",
        "project_binding_completed",
        "project_binding_historical",
        "project_binding_status_invalid",
        "project_instance_completed",
        "project_instance_missing",
        "project_instance_status_invalid",
        "project_review_only_after_end",
        "project_start_requires_published",
        "project_step_locked",
        "public_course_start_requires_published",
        "result_task_requires_submission_flow",
        "task_not_in_record",
        "teaching_plan_missing",
        "teaching_plan_task_inactive",
      ],
    },
    {
      prefix: "edu.overview.",
      resourceI18nKey: "common.errors.apiCodeResources.eduOverview",
      reasonCodes: ["learner_entry_not_found", "learner_message_not_found"],
    },
    {
      prefix: "edu.project.",
      resourceI18nKey: "common.errors.apiCodeResources.eduProject",
      reasonCodes: [
        "current_user_member_inactive",
        "end_only_from_published",
        "exam_access_denied",
        "exam_api_not_configured",
        "exam_api_unavailable",
        "exam_binding_unavailable",
        "exam_bridge_rejected",
        "exam_invalid_payload",
        "exam_invalid_token",
        "exam_options_unavailable",
        "exam_paper_not_found",
        "exam_result_requires_published",
        "exam_step_locked",
        "exam_step_paper_binding_missing",
        "exam_step_pass_score_invalid",
        "exam_step_pass_score_missing",
        "exam_step_required",
        "invalid_course_binding",
        "invalid_execution_status",
        "invalid_lifecycle_status",
        "invalid_member_id",
        "invalid_member_status",
        "invalid_paper_binding",
        "invalid_step_node_type",
        "invalid_unlock_template",
        "manual_release_requires_published",
        "manual_release_step_requires_manual_unlock",
        "member_not_assigned",
        "member_not_found_or_inactive",
        "publish_only_from_draft",
        "session_required",
        "step_bound_course_not_found",
        "step_completion_summary_required",
        "step_course_binding_missing",
        "step_course_binding_required",
        "step_exam_binding_required",
        "step_not_found",
        "step_scheduled_release_only_for_scheduled_unlock",
        "step_scheduled_release_required",
        "step_source_course_scheme_missing",
        "step_title_required",
        "step_unlock_rule_summary_required",
        "steps_edit_only_in_draft",
      ],
    },
    {
      prefix: "edu.public_course.",
      resourceI18nKey: "common.errors.apiCodeResources.eduPublicCourse",
      reasonCodes: [
        "course_scheme_catalog_missing",
        "snapshot_missing",
        "snapshot_scheme_missing",
        "snapshot_up_to_date",
        "source_course_not_found",
        "source_missing",
        "source_snapshot_forbidden",
      ],
    },
    {
      prefix: "edu.teaching_plan.",
      resourceI18nKey: "common.errors.apiCodeResources.eduTeachingPlan",
      reasonCodes: [
        "course_not_found",
        "course_scheme_catalog_missing",
        "end_only_from_published",
        "invalid_member_id",
        "member_not_found_or_inactive",
        "member_role_conflict",
        "no_learner_submissions",
        "publish_only_from_draft",
        "review_ended_only",
        "snapshot_catalog_missing",
        "task_submission_not_found",
      ],
    },
  ];
